/*
===============================================================================================================
                                 Copyright 2026-2026, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

import luiPortalUtilitiesManager from '../lui-portal-utilities-manager';

/**
 * Retrieves realm preferences for the returns-portal application from Portal.
 *
 * @returns {Promise<Record<string, unknown>>} Realm preferences for returns-portal application
 */
export const getPreferencesFromPortal = async () => {
  const data = await luiPortalUtilitiesManager
    .fetchUserPreferences()
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error('Error fetching user preferences from Portal:', error);
      throw error;
    });
  const realm = data?.userPreferences?.data?.realm;

  if (!realm || typeof realm !== 'object') return {};

  const returnsPortal = realm['returns-portal'];

  return returnsPortal && typeof returnsPortal === 'object' ? { ...returnsPortal } : {};
};

export default {
  getPreferencesFromPortal,
};
